$(document).ready(function () {

    // var slidesNum = 100000
    let clientSay = new Swiper('.js-client-say', {

        loop: true,
        // autoplay: {
        //     delay: 10,
        //     disableOnInteraction: false
        // },
        // autoplay: false,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="outer-dot swiper-pagination-bullet"><span class="inner-dot"></span></span>`;
            },
        },
        // slidesPerView: 'auto',
        // speed: 3500,
        // grabCursor: true,
        // paginationClickable: true,
        // mousewheelControl: true,
        // keyboardControl: true,

        // loop: true,
        // freeMode: true,
        // spaceBetween: 0,
        // grabCursor: true,
        // // slidesPerView: 7,
        // loop: true,
        // autoplay: {
        //     delay: 0,
        //     disableOnInteraction: true,
        //     waitForTransition: false,
        // },
        // draggable: true,
        // // freeMode: true,
        // speed: 2000,
        // freeModeMomentum: false,

        breakpoints: {
            360: {
                slidesPerView: 1,
                // spaceBetween: 24,
                // resistanceRatio: 0.85
            },
            768: {
                slidesPerView: 1,
                // spaceBetween: 28,
                // resistanceRatio: 0.85
            },
            980: {
                slidesPerView: 1,
                // spaceBetween: 28,
                // resistanceRatio: 0.85
            },
            1280: {
                slidesPerView: 1,
                // spaceBetween: 32,
                // resistanceRatio : 0
            },
        },

    });




});